import React, { useState } from "react";
import { Modal } from "antd";
import { Icon } from "@iconify/react";

const AddEditGroupModal = ({ opengroupModal, setopengroupModal }) => {
  const [isChecked, setIsChecked] = useState(false);
  const handleCheckboxChange = () => {
    setIsChecked(!isChecked);
  };
  const handleOk = () => {
    setopengroupModal(false);
  };
  const handleCancel = () => {
    setopengroupModal(false);
  };
  return (
    <>
      <Modal
        open={opengroupModal}
        onOk={handleOk}
        onCancel={handleCancel}
        className="editgroup-modal"
        centered={true}
        width="35%"
      >
        <div className="modal-content my-4">
          <h2 className="fw-bold text-medium-black text-center">
            Add / Edit Group
          </h2>
          <form>
            <div className="template-div v-center h-center flex-column mt-5">
              <div className="edit-profile-main d-flex flex-column gap-2">
                <div className="edit-profile-inner d-flex flex-column gap-3">
                  <h5>Add Group</h5>
                  <input
                    type="text"
                    placeholder="Enter group name..."
                    className="modal-input "
                  ></input>
                </div>
                <div className="check-me-div d-flex gap-2">
                  <input
                    type="checkbox"
                    id="customCheckboxSelectAll"
                    style={{ display: "none" }}
                    checked={isChecked}
                    onChange={handleCheckboxChange}
                  />
                  <label
                    htmlFor="customCheckboxSelectAll"
                    className="customCheckboxLabel"
                  >
                    <span
                      className="customCheckboxTick"
                      style={{
                        background: isChecked ? "#435AB8 " : "transparent",
                      }}
                    >
                      {isChecked && (
                        <span>
                          <Icon
                            icon="tabler:check"
                            width={20}
                            height={18}
                            color="#FFFFFF"
                          />
                        </span>
                      )}
                    </span>
                  </label>
                  <label className="elarge "> Public group</label>
                </div>
              </div>

              <div className="modal-bottom-btns d-flex flex-column gap-2 mb-4 mt-5">
                <button
                  className="modal-dark-btn "
                  style={{ width: "317px" }}
                  onClick={handleCancel}
                >
                  Close
                </button>
                <button
                  className="modal-dark-btn "
                  style={{ width: "317px" }}
                  onClick={handleCancel}
                >
                  Save
                </button>
                <button
                  className="modal-trans-btn"
                  onClick={handleOk}
                  style={{ width: "317px" }}
                >
                  Reset
                </button>
              </div>
            </div>
          </form>
        </div>
      </Modal>
    </>
  );
};

export default AddEditGroupModal;
